import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Nenhuma campanha ainda',
  hint: 'Quando a equipe Bodyprint aprovar uma oferta e criar a campanha, os números e os contatos aparecem aqui.',
  offers: 'Ver ofertas',
} satisfies TranslationTree;
